import { useParseContentForQuestion } from '@exam-management/rich-text-editor';
import { ContentPreviewer } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

function useParseQuestionContent(content: string, questionId: string) {
  const { parseContentForQuestion } = useParseContentForQuestion({ questionId });
  const [parsedContent, setParsedContent] = useState('');

  const handleParsedImage = useCallback(async () => {
    if (!content) return;

    const parsedContent = await parseContentForQuestion(content);

    setParsedContent(parsedContent);
  }, [content, parseContentForQuestion]);

  useEffect(() => {
    handleParsedImage();
  }, [handleParsedImage]);

  return {
    content: parsedContent,
  };
}

interface QuestionContentPreviewerProps {
  content: string;
  questionId: string;
}

export default function QuestionContentPreviewer(props: Readonly<QuestionContentPreviewerProps>) {
  const { content, questionId } = props;
  const { content: parsedContent } = useParseQuestionContent(content, questionId);

  return <ContentPreviewer content={parsedContent} />;
}
